import UI_CONSTANTS from '~/config/ui'

export const replaceNoUnitCharacter = (unit, replacement) => (
  unit === UI_CONSTANTS.NO_UNIT_CHAR ? replacement : unit
)

export const hasUnit = unit => unit !== UI_CONSTANTS.NO_UNIT_CHAR
